let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ibeF2")).then(() => parcelRequire('faNe9'));